import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.scss";
import Gateway from "./pages/gateway/Gateway";
import Threedsv from "./pages/3dsv/threedsv";
import Interac from "./pages/interac/interac";
import Redirect from "./pages/redirect/redirect";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "./themes/ThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <ToastContainer />
    <BrowserRouter>
      <Routes>
        <Route path="payment/:env/:refno" element={<Gateway />}></Route>
        <Route path="purchase-3dsv/:txid" element={<Threedsv />}></Route>
        <Route path="redirect/:env/:txid" element={<Redirect />}></Route>
        <Route path="interac-sandbox/:txid" element={<Interac />}></Route>
      </Routes>
    </BrowserRouter>
  </ThemeProvider>,
);
